/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Learn_Blocknumber1Inputs */

const zh_learn_blocknumber1 = /** @type {(inputs: Learn_Blocknumber1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`题块 ${i?.index}`)
};

const en_learn_blocknumber1 = /** @type {(inputs: Learn_Blocknumber1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Block ${i?.index}`)
};

const es_learn_blocknumber1 = /** @type {(inputs: Learn_Blocknumber1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bloque ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Block {index}" |
*
* @param {Learn_Blocknumber1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_blocknumber1 = /** @type {((inputs: Learn_Blocknumber1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Blocknumber1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_blocknumber1(inputs)
	if (locale === "en") return en_learn_blocknumber1(inputs)
	return es_learn_blocknumber1(inputs)
});
export { learn_blocknumber1 as "learn_blockNumber" }